class GlobalVariables {
    constructor() {
        this.executed = false;
        this.minimized_class = 'minimized';
        this.active_class = 'active';
        this.modal_active_class = "modal-active",
        this.location_path = [];
        this.ie_version = false;
        this.cookie_expires = 7;
        this.cookie_path = "";
        this.zoom_class = 'zoommode';
    }

    // Setters.
    setLocationPath(path) {
        this.location_path = path;
    }

    setIEVersion(version) {
        this.ie_version = version;
    }

    setExecuted(value) {
        this.executed = value;
    }

    // Getters.
    getLocationPath() {
        return this.location_path;
    }
}

export default (new GlobalVariables);
